import React, { useState } from "react";
import { useIntl } from "react-intl";
import classNames from "classnames";
import { useCreateSkill } from "@/query/skill";
import { useAgentId, useModal } from "@/hook";
import Button from "@/component/Button";
import { Modal } from "@/component/modal";
import { errorToast, successToast } from "@/component/Toast";


export const SKILL_ADD_MODAL_ID = "selectedSkill-add-modal-id";

const SkillAddModal: React.FC = () => {
    const intl = useIntl();
    const modal = useModal();
    const agentId = useAgentId();

    const [validated, setValidated] = useState<boolean>(false);
    const [name, setName] = useState<string>("");

    const { mutateAsync: createSkill, isPending: isCreating } = useCreateSkill(agentId);

    const onClickConfirm = async () => {
        setValidated(true);

        const form = {
            name: name.trim()
        };
        if (!form.name) {
            return;
        }
        await createSkill(form)
            .then(() => {
                successToast(intl.formatMessage({ id: "t001" }));
                setValidated(false);
                modal.close(SKILL_ADD_MODAL_ID);
            })
            .catch(() => {
                errorToast(intl.formatMessage({ id: "t002" }));
            });
    };

    return (
        <Modal id={SKILL_ADD_MODAL_ID}
               size="sm"
               title={intl.formatMessage({ id: "i03009" })}
               onClose={() => {
                   setValidated(false);
                   setName("");
               }}
        >
            <div className="modal-body">
                <input className={classNames(
                           "modal-input",
                           validated && !name?.trim() && "input-invalid"
                       )}
                       value={name}
                       placeholder={intl.formatMessage({ id: "i03010" })}
                       onChange={e => setName(e.target.value)}
                />
                <div className="modal-btn-group">
                    <Button size="sm"
                            variant="secondary"
                            onClick={() => modal.close(SKILL_ADD_MODAL_ID)}
                    >
                        {intl.formatMessage({ id: "b0002" })}
                    </Button>
                    <Button size="sm"
                            variant="primary"
                            disabled={isCreating}
                            onClick={onClickConfirm}
                    >
                        {intl.formatMessage({ id: "b0001" })}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default SkillAddModal;
